import { render, staticRenderFns } from "./PartnerProductPurchaseDialog.vue?vue&type=template&id=d594c050&"
import script from "./PartnerProductPurchaseDialog.vue?vue&type=script&lang=ts&"
export * from "./PartnerProductPurchaseDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports